// Google Analytics service
class AnalyticsService {
  constructor() {
    this.isInitialized = false;
    this.measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';
  }

  // Initialize Google Analytics
  init() {
    if (this.isInitialized || typeof window === 'undefined') return;

    // Only initialize if we have a valid measurement ID
    if (this.measurementId === 'G-XXXXXXXXXX') {
      console.warn('Google Analytics not configured. Please set REACT_APP_GA_MEASUREMENT_ID environment variable.');
      return;
    }

    // Load Google Analytics script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', this.measurementId, {
      page_title: document.title,
      page_location: window.location.href
    });

    this.isInitialized = true;
    console.log('Google Analytics initialized');
  }

  // Track page views
  trackPageView(pagePath, pageTitle) {
    if (!this.isInitialized || !window.gtag) {
      console.warn('Google Analytics not initialized. Page view not tracked:', pagePath);
      return;
    }

    window.gtag('config', this.measurementId, {
      page_path: pagePath,
      page_title: pageTitle
    });
  }

  // Track custom events
  trackEvent(eventName, parameters = {}) {
    if (!this.isInitialized || !window.gtag) {
      console.warn('Google Analytics not initialized. Event not tracked:', eventName);
      return;
    }

    window.gtag('event', eventName, parameters);
  }

  // Track bubble interactions
  trackBubbleClick(thoughtId, thoughtTitle, author) {
    this.trackEvent('bubble_click', {
      thought_id: thoughtId,
      thought_title: thoughtTitle,
      author: author,
      event_category: 'engagement'
    });
  }

  // Track video interactions
  trackVideoPlay(thoughtId, videoUrl) {
    this.trackEvent('video_play', {
      thought_id: thoughtId,
      video_url: videoUrl,
      event_category: 'video'
    });
  }

  // Track share events
  trackShare(thoughtId, method) {
    this.trackEvent('share', {
      thought_id: thoughtId,
      method: method,
      event_category: 'social'
    });
  }

  // Track admin actions
  trackAdminAction(action, details = {}) {
    this.trackEvent('admin_action', {
      action: action,
      ...details,
      event_category: 'admin'
    });
  }
}

// Create singleton instance
const analyticsService = new AnalyticsService();

export default analyticsService;
